import { CatalogGiftPayloadTypes } from "utilities/types/CatalogGift";
import { Dispatch } from "redux";
import { showMessage } from "utilities/helper";
import CatalogGiftService from "service/CatalogGift";
import { setLoading, setLoadingModal } from "./global";
import { getCatalogById } from "./catalog";

export const getAllCatalogGifts =
  (
    catalogId?: string | undefined,
    page: number = 1,
    search: string = "",
    limit: number = 10
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_CATALOG_GIFT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_CATALOG_GIFT",
      searchValue: search,
    });

    try {
      const data = await CatalogGiftService.getAllCatalogGifts(
        catalogId,
        page,
        search,
        limit
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_CATALOG_GIFT",
        value: data.catalog_gifts,
      });
      dispatch({
        type: "SET_CATALOG_GIFT_PAGE",
        totalPage: !!data.catalog_gifts.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalog_gifts.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getAllCatalogGiftDetails =
  (
    checkoutId: string,
    page: number = 1,
    search: string = "",
    limit: number = 10
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoadingModal(true));
    dispatch({
      type: "SET_CATALOG_GIFT_DETAIL_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_CATALOG_GIFT_DETAIL",
      searchValue: search,
    });

    try {
      const data = await CatalogGiftService.getAllCatalogGiftDetails(
        checkoutId,
        page,
        search,
        limit
      );

      dispatch(setLoadingModal(false));
      dispatch({
        type: "SET_CATALOG_GIFT_DETAIL",
        value: data.catalog_gift_details,
      });
      dispatch({
        type: "SET_CATALOG_GIFT_DETAIL_PAGE",
        totalPage: !!data.catalog_gift_details.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalog_gift_details.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoadingModal(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeCatalogGift =
  (
    catalogId: string | undefined,
    form: CatalogGiftPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogGiftService.storeCatalogGift(
        catalogId,
        payload
      );
      const { currentPage, searchValue, limitPage } =
        getState().catalogGiftReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogGifts(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
